import React, { useEffect } from 'react';
import { AlertContainer, AlertIcon } from './styles';
import { BsExclamation, BsCheck } from 'react-icons/bs';
import colors from '../../assets/styles/colors';

const AlertComponent = ({ description, warning, danger, success, default: primary, style, borderAlert, backgroundAlert, backgroundIcon, icon, custom }) => {
  return (
    <>
      {warning && (
        <AlertContainer style={style} border={colors.bgTertiary} background={colors.bgTertiaryShadow}>
          <AlertIcon background={colors.bgTertiary}>
            <BsExclamation color={colors.textPrimary} />
          </AlertIcon>
          {description}
        </AlertContainer>
      )}

      {danger && (
        <AlertContainer style={style} border={colors.bgDanger} background={colors.bgDangerShadow}>
          <AlertIcon background={colors.bgDanger}>
            <BsExclamation color={colors.white} />
          </AlertIcon>
          {description}
        </AlertContainer>
      )}

      {success && (
        <AlertContainer style={style} border={colors.textHyperlink} background={colors.bgFilterSelected}>
          <AlertIcon background={colors.textHyperlink}>
            <BsCheck color={colors.white} />
          </AlertIcon>
          {description}
        </AlertContainer>
      )}

      {primary && (
        <AlertContainer style={style} border={colors.grayLight} background={colors.textExGrayLight}>
          <AlertIcon background={colors.grayLight}>
            <BsExclamation color={colors.black} />
          </AlertIcon>
          {description}
        </AlertContainer>
      )}

      {custom && (
        <AlertContainer style={style} border={borderAlert} background={backgroundAlert}>
          <AlertIcon background={backgroundIcon}>
            {icon}
          </AlertIcon>
          {description}
        </AlertContainer>
      )}
    </>
  )
}

export default AlertComponent;
